var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54767 16.5703C3.70744 16.5703 1.03839 16.5693 0.198162 16.5703L0.220434 17.9026C4.37196 17.9127 13.9383 17.9117 18.0898 17.9086L18.0655 16.5703H12.1026C12.5369 16.3375 12.8325 15.8789 12.8325 15.3525C12.8325 14.5902 12.2129 13.9707 11.4507 13.9707C10.6884 13.9707 10.0688 14.5902 10.0688 15.3525C10.0688 15.8789 10.3644 16.3365 10.7987 16.5703H8.28919H5.85052C6.28481 16.3375 6.5804 15.8789 6.5804 15.3525C6.5804 14.5902 5.96087 13.9707 5.19859 13.9707C4.43631 13.9707 3.81677 14.5902 3.81677 15.3525C3.81677 15.8789 4.11338 16.3375 4.54767 16.5703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5977 14.2883C13.2049 13.4997 12.392 12.9571 11.4526 12.9571C10.1993 12.9571 9.16879 13.9249 9.06756 15.1529C8.57152 15.1761 8.0765 15.1812 7.58755 15.1721C7.49543 13.935 6.46084 12.9571 5.2005 12.9571C4.11225 12.9571 3.19206 13.687 2.90152 14.6821C1.78898 14.4817 0.87384 14.26 0.277584 14.1021C0.900162 11.6988 3.15865 4.29369 7.94186 1.49868C11.2876 -0.454087 15.5839 0.67465 17.5366 4.01936C19.4894 7.36406 18.3637 11.6573 15.02 13.6121C14.5685 13.8763 14.0927 14.1 13.5977 14.2883ZM13.8832 6.15231C13.1756 4.94158 11.6196 4.53361 10.4089 5.24123C9.19815 5.94884 8.79019 7.50477 9.4978 8.71551C10.2054 9.92624 11.7613 10.3342 12.9721 9.6266C14.1828 8.91899 14.5908 7.36305 13.8832 6.15231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.632e7a230d701f77dd74de1d7af92739.svg";
export { ForwardRef as ReactComponent };